import type { PreviewMode } from "../domain/settings";

/**
 * Whether an event's hover card may show, given the details card (ENG-2282, Chen "Silver",
 * 2026-10-05). The hover card is an MUI Tooltip at `zIndex.tooltip` (1500): above the
 * floating card (`zIndex.modal`, 1300) and the docked rail, so before this it sat on top of
 * the card it summarises.
 *
 * - `"show"`: no card is open — hover exactly as before (delay, placement, privacy).
 * - `"hide"`: this event's own card is open (floating or docked), or any card floats.
 * - `"grid"`: a card is DOCKED and this is another event — show it, but kept inside the
 *   grid's scroll container so it never covers the rail.
 */
export type HoverGate = "show" | "hide" | "grid";

export function hoverGate(
  eventId: string,
  previewEventId: string | null,
  previewMode: PreviewMode
): HoverGate {
  if (previewEventId === null) return "show";
  if (previewEventId === eventId) return "hide";
  return previewMode === "docked" ? "grid" : "hide";
}
